<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="d14be04baee4e-d1e230"><span id="pageii">
<h3 class="books-by-head"><em class="italic ">A Selection of Recent Titles by Marjorie Eccles</em></h3>
<p class="books-by-text">THE SHAPE OF SAND</p>
<p class="books-by-text">SHADOWS AND LIES</p>
<p class="books-by-text">LAST NOCTURNE</p>
<p class="books-by-text">BROKEN MUSIC</p>
<p class="books-by-text">THE CUCKOO’S CHILD *</p>
<p class="books-by-text">AFTER CLARE *</p>
<p class="books-by-text">A DANGEROUS DECEIT *</p>
<p class="books-by-text-space-after">THE FIREBIRD’S FEATHER *</p>
<p class="books-by-text-space-after"><em class="italic ">The Herbert Reardon historical mysteries</em></p>
<p class="books-by-text-space-after">HEIRS AND ASSIGNS *</p>
<p class="books-by-text">* <em class="italic ">available from Severn House</em></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106915_epub_alb.vue?c71183b2